module.exports = __webpack_public_path__ + "static/media/GO_P_enriched_and_unique_terms.86d035b4.zip";